var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 109,
    viewBox: "0 0 111 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.8298,
    cy: 81.5865,
    r: 5.74376,
    transform: "rotate(29.7509 86.8298 81.5865)",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1685,
    cy: 88.0343,
    r: 7.97745,
    transform: "rotate(29.7509 51.1685 88.0343)",
    fill: "#A9BCFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.7335,
    cy: 54.5474,
    r: 13.083,
    transform: "rotate(29.7509 24.7335 54.5474)",
    fill: "#D9A6FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.6909,
    cy: 11.7635,
    rx: 6.70106,
    ry: 6.38196,
    transform: "rotate(29.7509 36.6909 11.7635)",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.0278,
    cy: 50.3689,
    r: 7.97745,
    transform: "rotate(29.7509 58.0278 50.3689)",
    fill: "#ABD354"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.ea7391f2c6a995d95bd38342f6850b61.svg";
export { ForwardRef as ReactComponent };